// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"8b61883a","556":"f033a7c0","592":"61e57903","843":"f2d9ed15","990":"b5a358ac"}[chunkId] + ".chunk.js";
};